module.exports = "https://static-www.niulinkcloud.com/_next/static/media/mobileBanner.da0bee06d4aaf8996de9c27ab3a9bfd4.png";